import { render } from "./user-card.template.html?vue&type=template&id=3a855226&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=3a855226&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a855226"

export default script